console.log('Site designed by %cparallelbrandagency.com', 'color: #D6001C');
import initNavigation from './navigation.js';
import initAccordions from './accordions.js';
import initSwiperSliders from './swiperSliders.js';
import initAnimations from './siteAnimations.js';
// import initBarbaTransitions from './barbaTransitions.js';


document.addEventListener('DOMContentLoaded', () => {
  // Initialize navigation
  initNavigation();

  // Initialize Swiper sliders
  initSwiperSliders();

  // Initialize accordions
  initAccordions();

  // Initialize site animations
  initAnimations();

  // Initialize Barba transitions
  //initBarbaTransitions();
});



/************************** 
 * UTILITIES
***************************/
// check when an element enters the viewport
function isScrolledIntoView(elem) {
  let docViewTop = jQuery(window).scrollTop();
  let docViewBottom = docViewTop + jQuery(window).height();

  let elemTop = jQuery(elem).offset().top;
  let elemBottom = elemTop + jQuery(elem).height();

  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}